import { useCallback, useState } from 'react';
import { animateCamera, getCurrentViewData } from '../utils/threeJsUtils';
import { initialCameraHeight, minPolarAngle, maxPolarAngle, initialLookAt } from '../Components/CameraController';
import { gsap } from "gsap";
import { Box3, Quaternion, Vector3 } from 'three';


/**
 * Custom hook for managing camera controls
 * @param {Object} params - Parameters
 * @param {React.RefObject} params.camera - Camera ref
 * @param {React.RefObject} params.controls - OrbitControls ref
 * @param {Object} params.projectDefaultView - Project default view settings
 * @returns {Object} Camera control functions
 */
export const useCameraControls = ({ camera, controls, projectDefaultView }) => {
  const [lastCameraViewData, setLastCameraViewData] = useState(null);
  const setControls = useCallback(() => {
    if (controls.current) return;
    
    console.log("setControls", controls.current);
    controls.current.screenSpacePanning = false;
    controls.current.target.set(0, initialCameraHeight, 0);
    controls.current.enabled = false;
    controls.current.enableRotate = false;
    controls.current.enableDamping = false;
    controls.current.enableZoom = false;
    controls.current.enablePan = false;
    controls.current.dampingFactor = 0.035;
    controls.current.minPolarAngle = minPolarAngle;
    controls.current.maxPolarAngle = maxPolarAngle;
    controls.current.maxDistance = projectDefaultView.maxDistance || 200;
    controls.current.update();
  }, [controls, projectDefaultView]);

  const enableControls = useCallback(() => {
    if (controls.current) {
        console.log("enableControls", controls.current);
      controls.current.enabled = true;
      controls.current.enableRotate = true;
      controls.current.enableDamping = true;
      controls.current.enableZoom = true;
      controls.current.enablePan = true;
      controls.current.minPolarAngle = minPolarAngle;
      controls.current.maxPolarAngle = maxPolarAngle;
      controls.current.update();
    }
  }, [controls]);

  const disableControls = useCallback(() => {
    if (controls.current) {
        console.log("disableControls", controls.current);
      controls.current.enabled = false;
      controls.current.enableRotate = false;
      controls.current.enableDamping = false;
      controls.current.enableZoom = false;
      controls.current.enablePan = false;
    }
  }, [controls]);

  const setControlsTarget = useCallback((position) => {
    if (controls.current) {
      controls.current.target.set(position.x, position.y, position.z);
    }
  }, [controls]);

  const saveCameraViewData = useCallback(() => {
    if (camera.current) {
      return getCurrentViewData(camera.current);
    }
    return null;
  }, [camera]);

  const moveCameraToView = useCallback((viewData, duration = 1) => {
    if (camera.current && viewData) {
      return animateCamera(
        camera.current,
        viewData.position,
        viewData.quaternion,
        duration
      );
    }
  }, [camera]);
  const moveToNode = (node) => {
    console.log("moveToNode", node);
    if (node) {
      const boundingBox = new Box3().setFromObject(node);
      const center = boundingBox.getCenter(new Vector3());
      center.y += 1;
      let straightForwardQuaterion = new Quaternion();
      const targetNode = node.children.find((n) => n.name.includes("target"));
      console.log("targetNode", targetNode);
      if (targetNode) {
        targetNode.visible = true;
        const targetNodePosition = targetNode.position;
        // calculateQuaternian to face the target node
        // const targetNodeDirection = new THREE.Vector3().subVectors(
        //   targetNodePosition,
        //   center
        // );
        // targetNodeDirection.y = 0; // Ignore the y component for horizontal rotation
        // targetNodeDirection.normalize();
        // straightForwardQuaterion.setFromUnitVectors(
        //   new THREE.Vector3(0, 0, -1),
        //   targetNodeDirection
        // );

        // cameraControls.animateLookAtPosition(targetNodePosition, 2);
      }
      animateCamera(camera.current, center, straightForwardQuaterion, 2);
    }
  };
function animateLookAtPosition(
    targetPosition,
    duration,
    easeName = "power4.out"
  ) {
    if (targetPosition) {
      return new Promise((resolve) => {
        gsap.to(controls.current.target, {
          duration: duration,
          x: targetPosition.x,
          y: targetPosition.y,
          z: targetPosition.z,
          ease: easeName, // or any other easing function
          // onUpdate: () => {
          //   camera.updateProjectionMatrix();
          // }, // required when the camera position is changing
          onComplete: () => {
    //             controls.current.target.copy(targetPosition);
    // controls.current.update();
            resolve();
          },
        });
      });
    }
  }
  const moveCameraToLastView = useCallback(() => {
    console.log("resetCameraToLastView", lastCameraViewData);
    if (lastCameraViewData) {
      setTimeout(() => {          // lookAtPosition.current = initialLookAt;
        animateLookAtPosition(initialLookAt , 1);
        animateCamera(
          camera.current,
          lastCameraViewData.position,
          lastCameraViewData.quaternion,
          1
        );

      }, 200);
    }
  }, [lastCameraViewData]);
  return {
    setControls,
    enableControls,
    disableControls,
    setControlsTarget,
    saveCameraViewData,
    moveCameraToView,
    animateLookAtPosition,
    moveToNode,
    lastCameraViewData,
    setLastCameraViewData,
    moveCameraToLastView,
  };
};
